import { DateRange } from 'map-wald';
import { PaletteDescriptor } from 'map-wald';

export type AggregationFunction = 'sum'|'mean'|'min'|'max';
export interface MetadataConfig {
  filename?:string;
  meta:string[];
  variables?:string[];
  variable?:string;
  shortVariable?:string;
  drillVariable?:string;
  script?:string[];
  masks?:{
    normal?:string;
    anomaly?:string;
  },
  dataModes?:boolean; // NOT IMPLEMENTED
}

export interface RelativeOption {
  variable:string;
  palette?: PaletteDescriptor;
}

export interface LayerStyling {
  palette:PaletteDescriptor,
  classes:number[],
  below?:string,
  above?:string,
  reverseAnomalyPalette?:boolean,
  classMultipliers?:number[],
  trendScale?:number,
  anomalyLimit?:number,
  anomalyClasses?:number[]
}

export interface LayerDescriptorCommon {
  label:string;
  legendLabel?:string;
  description?:string;
  legendLabels?:string[];
  zonal?:string;
  pointStyles?:LayerStyling;
  zonalStyles?:LayerStyling;
  gridStyles?:LayerStyling;
  summable?:boolean;
  aggregation?:AggregationFunction;
  globalAggregation?:AggregationFunction;
  collection?:string;
  summary?:string;
  combine?:string[];
  resolution:number;
  rankVariable?:string;
  rankWeight?:number;
}

export interface LayerVariant extends LayerDescriptorCommon {
  variantLabel:string;
  relative?:RelativeOption;
  bin?:string; // NOT USED?
}

export interface LayerDescriptor extends MetadataConfig, LayerDescriptorCommon {
  type:string;
  source:string;
  tileserver?:string;
  server?:string;
  icon?:string;
  attribution?:string;
  attributionURL?:string;
  metadata?:string;
  url?: string;
  polygonDrill?: string;
  polygonDrillHeaders?: any;
  time:string;
  timeFirst:boolean;
  mapParams?:any;
  timePeriod?:DateRange;
  relatedFiles?:MetadataConfig[];
  // relativeOptions?:{[key:string]:RelativeOption};
  help?: string;
  variants?:LayerVariant[];
  chartLabel?:string;
  units?:string;
  scale?:number;
}

export interface FlattenedLayerDescriptor extends LayerDescriptor, LayerVariant { }

// export interface LayerDescriptor {
//   label: string;
//   name: string;
//   options?: {
//     temporal?: boolean;
//     threshold?: boolean;
//     delta?: boolean;
//     range?: number[];
//     deltaOffset?: number;
//   };
//   units: string;
//   help?: string;
// }

export function getAggregation(layer:LayerDescriptor):AggregationFunction{
  if(layer.aggregation){
    return layer.aggregation;
  }

  if(layer.summable){
    return 'sum';
  }

  return 'mean';
}
